<template>
  <div class="content content_in sat-page">
    <div class="sat-page__head">
      <div class="sat-page__titles">
        <router-link v-if="back" :to="back" class="sat-page__back">
          <SatIcon name="back" :size="16" />
          {{ backLabel }}
        </router-link>
        <h1 class="sat-page__title">
          {{ title || $t("satellites.title") }}
          <slot name="title-extra" />
        </h1>
      </div>
      <div v-if="$slots.actions" class="sat-page__actions">
        <slot name="actions" />
      </div>
    </div>
    <SatellitesTabs v-if="tabs" />
    <slot />
    <alert v-if="$alert.title" />
  </div>
</template>
<script>
import SatellitesTabs from "@/components/Satellites/SatellitesTabs.vue";
import SatIcon from "@/components/Satellites/SatIcon.vue";
import "@/components/Satellites/satellites.scss";

// Frame of every satellite page: title, actions, the section tabs and the shared look (satellites.scss).
export default {
  name: "SatellitesPage",
  components: { SatellitesTabs, SatIcon },
  props: {
    title: {
      type: String,
      default: "",
    },
    // Route of the "back" link of a detail page; detail pages have no tabs.
    back: {
      type: Object,
      default: null,
    },
    backLabel: {
      type: String,
      default: "",
    },
  },
  computed: {
    tabs() {
      return !this.back;
    },
  },
};
</script>
<style lang="scss" scoped>
.sat-page {
  padding-bottom: 150px;
}

.sat-page__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px 24px;
  margin-bottom: 18px;
}

.sat-page__titles {
  min-width: 0;
}

.sat-page__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: var(--sat-muted);

  &:hover {
    color: var(--sat-accent);
  }
}

.sat-page__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 22px;
  word-break: break-word;
  color: var(--sat-text);

  @media screen and (min-width: 768px) {
    font-size: 26px;
  }
}

.sat-page__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
